import React, { ReactNode } from "react";
import { CTAButton } from "./CTAButton";
type Tone = "navy" | "white" | "paper";
interface SectionProps {
  id?: string;
  tone: Tone;
  children: ReactNode;
  cta: {
    label: string;
    sub?: string;
  };
  afterCta?: ReactNode;
}
const toneClasses: Record<Tone, string> = {
  navy: "bg-navy-950 text-white",
  white: "bg-white text-ink",
  paper: "bg-paper text-ink"
};
export function Section({
  id,
  tone,
  children,
  cta,
  afterCta
}: SectionProps) {
  return <section id={id} className={`w-full ${toneClasses[tone]}`} data-id="element-288" data-mp="herpb7cvt2oe">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-289" data-mp="hdyh01y9y545">
        {children}
        <div className="mt-12 md:mt-14" data-id="element-290" data-mp="2p2cufzc9c8t">
          <CTAButton label={cta.label} sub={cta.sub} tone={tone === "navy" ? "dark" : "light"} data-id="element-291" data-mp="2o0wpx3gtzk8" />
          {afterCta}
        </div>
      </div>
    </section>;
}